import Layout from "@/components/Layout";
import { GuideContent } from "@/pages/Guide";
import { BookOpen } from "@phosphor-icons/react";

export default function GuideApp() {
  return (
    <Layout back="/app">
      <div className="mb-10">
        <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-[#1F6FE5] mb-3">
          <BookOpen size={16} weight="duotone" /> The complete guide
        </div>
        <h1 className="font-display font-black text-3xl sm:text-4xl tracking-tighter leading-tight max-w-3xl">
          Everything you need to run an election on SelectFlow.
        </h1>
        <p className="text-zinc-600 leading-relaxed max-w-2xl mt-4">
          A step-by-step walkthrough with screenshots for every stage — for organisers, nominees and voters. Follow it top to bottom, or jump to what you need.
        </p>
      </div>
      <GuideContent />
    </Layout>
  );
}
